import { createContext } from 'preact/compat';
console.log({ MODE });
export const configDefaults = {
    action: (MODE === 'development') ? '/php-files/postdata.php' : '',
    hideQuickPayButtons: false,
    modalTitle: undefined,
    modalDiscounts: undefined,
    discountBands: [],
    paymentIcons: [
        {
            src: 'https://placehold.co/98x32',
        },
        {
            src: 'https://placehold.co/72x56',
        },
        {
            src: 'https://placehold.co/92x44',
        },
        {
            src: 'https://placehold.co/98x40',
        },
    ],
};
export const ConfigCTX = createContext(configDefaults);
